"use client";

import { cn } from "../../../lib/utils";
import { TableRow, TableCell } from "../table";
import { Skeleton } from "../skeleton";
import type { DataTableLoadingProps } from "./types";

export function DataTableLoading({
  columns,
  rows = 10,
}: DataTableLoadingProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <TableCell key={colIndex}>
              <Skeleton className={cn("h-4 w-full", colIndex === 0 && "w-8")} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

DataTableLoading.displayName = "DataTableLoading";
